import template from './service_ticket_parts.all.html';
import controller from './service_ticket_parts.all.controller';
import './service_ticket_parts.all.scss';

const serviceTicketPartsAllComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default serviceTicketPartsAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/service_ticket_parts/all/service_ticket_parts.all.component.js